export default "__VITE_ASSET__DsTCWlfj__"